import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Apollo} from 'apollo-angular';

import { cloneDeep } from 'lodash';
import { NotificationApiService } from '../notification-api.service';
import { GetContactNotifications, INotification, ListNotificationQuery, SaveAssociateNotificationWithContact } from '@ebb-v2/ebb-integration';


@Injectable({
    providedIn: 'root'
  })
export class NotificationGqlService implements NotificationApiService {
    

    constructor(
        private apollo: Apollo
      ) {
        
      }

   

    public getList(): Observable<INotification[]> {
         
          return this.apollo
        .query({
          query: ListNotificationQuery,
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => 
          { 
            const returnNotifications =cloneDeep( result.data['notifications'] as INotification[]);
            
            return returnNotifications;
          }), take(1));   
    }
    public getContactNotifications(contactId: String): Observable<INotification[]> {
         
      return this.apollo
    .query({
      query: GetContactNotifications,
      variables: {
        contactId: contactId
       
      },
      fetchPolicy: 'network-only'
    })
    .pipe(map(result => 
      { 
        const returnNotifications =cloneDeep( result.data['getContactNotifications'] as INotification[]);
        
        return returnNotifications;
      }), take(1));   
}
    public saveAssociateNotificationWithContact(contactId: String,notificationId: String): Observable<INotification[]> {
         
      return this.apollo
    .mutate({
      mutation: SaveAssociateNotificationWithContact,
      variables: {
        contactId: contactId,
        notificationId:notificationId
      },
      fetchPolicy: 'network-only'
    })
    .pipe(map(result => 
      { 
        const returnNotifications =cloneDeep( result.data['saveAssociateNotificationWithContact'] as INotification[]);
        
        return returnNotifications;
      }), take(1));   
}
}